import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { MapPin, Mail } from 'lucide-react';
export function InstructorsCTA() {
  return <section className="py-16 bg-slate-50" data-id="element-401">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-402">
        <h2 className="text-3xl font-bold text-[#1a2332] mb-6" data-id="element-403">
          Want to train with our team?
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-404">
          <Link to="/locations" data-id="element-405">
            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-406">
              <MapPin className="h-5 w-5 mr-2" data-id="element-407" />
              View Locations
            </Button>
          </Link>
          <Link to="/contact" data-id="element-408">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white" data-id="element-409">
              <Mail className="h-5 w-5 mr-2" data-id="element-410" />
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}